export const persianMonths = [
  { id: 1, title: 'فروردین' },
  { id: 2, title: 'اردیبهشت' },
  { id: 3, title: 'خرداد' },
  { id: 4, title: 'تیر' },
  { id: 5, title: 'مرداد' },
  { id: 6, title: 'شهریور' },
  { id: 7, title: 'مهر' },
  { id: 8, title: 'آبان' },
  { id: 9, title: 'آذر' },
  { id: 10, title: 'دی' },
  { id: 11, title: 'بهمن' },
  { id: 12, title: 'اسفند' },
];

export const persianMonthTitle = (m) => {
  const pm = persianMonths.find((x) => x.id == m);
  return pm ? pm.title : m;
};
